module.exports = __webpack_public_path__ + "static/IBMPlexMono-BoldItalic-0cc0d044dbb4bff360916bceb8f288d0.woff";